<template>
  <div class="m-response-flow-summary">
    <a-summary-item-header :text="title" />
    <a-response-flow-summary-item
      v-for="(item, key) in list"
      :key="key"
      :label="item.label"
      :name="item.name"
      :active="item.active"
    />
  </div>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import AResponseFlowSummaryItem from '@/components/atoms/response-flow-summary-item/index.vue';
import ASummaryItemHeader from '@/components/atoms/summary-item-header/index.vue';

export default {
  name: 'm-response-flow-summary',
  components: {
    ASummaryItemHeader,
    AResponseFlowSummaryItem,
  },
  props: {
    title: {
      type: String,
      default: null,
    },
    list: {
      type: Object,
      default() {
        return {};
      },
    },
  },
};
</script>
